import { type Guard, UserCredentials, useSettings } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { CredentialGuard } from '@capsicum/socios-core-web';
import { useCallback } from 'react';

/**
 * Returns a route guard and onDenied action based on the "CHZ:SRV:VOTE" and "isPollEnabled" flags.
 */
export const useSurveyGuard: Guard = () => {
	const { settings } = useSettings();
	const { push } = useRouter();

	const isSurveyEnabled = !!settings?.isPollEnabled;
	const onDisabledFeature = useCallback(() => push('/'), [push]);

	const { onDenied: onDeniedCredential, status: credentialStatus } = CredentialGuard(UserCredentials.SURVEY_VOTE)();

	return {
		onDenied: isSurveyEnabled ? onDeniedCredential : onDisabledFeature,
		status: isSurveyEnabled ? credentialStatus : 'denied'
	};
};
